module.exports = __webpack_public_path__ + "img/BETWAY.4d313386.svg";